export default __webpack_public_path__ + "static/media/filter-gradient.1ca79ba4.png";